<template>
  <div :class="'user ' + (links_open ? 'open' : '')">
    <div class="avatar">
      <img :src="avatarSrc" />
    </div>
    <div class="info">
      <span class="name" v-html="displayName"></span>
      <div class="integration">
        <div class="integration--item">
          <div class="line" v-if="availability >= 0">
            <span>Credito</span>
            <span class="value">€ {{ availability }}</span>
          </div>
          <div class="line" v-if="discount_codes_availability > 0">
            <span>Buoni</span>
            <span class="value">€ {{ discount_codes_availability }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="toggler" @click="links_toggle">
      <div v-if="false" v-html="chevron_down"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { sum, number, round } from 'mathjs';
import { chevron_down } from '@/components/svg/chevrons';
export default {
  name: 'user',
  components: {},
  computed: {
    availability() {
      return round(this.config.integration.availability, 2);
    },
    discount_codes_availability() {
      let amount = 0;
      this.$store.state.discount_codes.forEach((dc) => {
        if (dc.valueResidual) amount = sum(amount, number(dc.valueResidual));
      });
      return amount;
    },
  },
  created() {
    this.chevron_down = chevron_down;
    window.addEventListener('scroll', () => {
      this.links_open = false;
    });
    document.addEventListener('click', () => {
      this.links_open = false;
    });
  },
  data() {
    return {
      config: Vue.prototype.$config,
      avatarSrc: '',
      displayName: '',
      links_open: false,
    };
  },
  mounted() {
    if (this.config.integration) {
      this.avatarSrc = this.config.integration ? this.config.integration.avatarSrc : '';
      this.displayName = this.config.integration ? this.config.integration.displayName : '';
    }
  },
  methods: {
    links_toggle(e) {
      e.stopPropagation();
      this.links_open = !this.links_open;
      return false;
    },
  },
};
</script>

<style lang="scss">
.user {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  .avatar {
    width: 40px;
    margin-right: 20px;
    img {
      min-width: 40px;
      max-width: 100%;
      height: auto;
    }
  }
  .info {
    width: 100%;
    height: 100%;
    max-width: 160px; //100%;
    .line {
      width: 120px;
      font-size: 11px;
      line-height: 100%;
      margin-top: 2px;
      display: flex;
      align-items: center;
      & > * {
        display: inline-block;
        min-width: 50%;
        max-width: 50%;
      }
    }
  }
  .name {
    @include font-primary-bold;
    display: inline-block;
    line-height: 100%;
    margin-bottom: 2px;
  }
  .integration {
    &--item {
      display: flex;
      flex-wrap: wrap;
    }
    .content {
      font-size: 14px;
    }
  }
  .value {
    color: $primary;
    @include font-primary-bold;
    white-space: nowrap;
    font-size: 12px;
  }
  .toggler {
    display: none;
    & > div {
      min-width: 40px;
      min-height: 40px;
    }
    path {
      transition: $transition-base;
      transform-origin: center center;
    }
  }

  @include media-breakpoint-up(lg) {
    position: relative;
    .content {
      display: none;
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 2rem;
      background: $white;
      padding: $border-radius-lg;
      border-radius: $border-radius-lg;
      li {
        white-space: nowrap;
      }
    }
    .toggler {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &.open {
      .toggler svg {
        transform: rotate(180deg);
      }
      .content {
        display: block;
      }
    }
  }
}
</style>
